import { ajax as request, request as newRequest } from '@blade/common';
export const fetchDeviceTree = () => newRequest.post(`/api/camera-device-management/api/v1/device-groups/devices/tree`, {});
/** ==============================@Description: 设备管理============================== */
/**
*@Description: 添加设备
*@Date: 2020-09-01 14:39:57
*/
export const postDevices = (data) => request({
    url: '/api/camera-device-management/api/v1/devices',
    method: 'POST',
    data
});
/**
*@Description: 查询设备详情
*@Date: 2020-09-01 14:39:57
*/
export const getDevicesDetail = (id) => request({
    url: '/api/camera-device-management/api/v1/devices/' + id,
    method: 'GET',
    params: {}
});
/**
*@Description: 修改设备
*@Date: 2020-09-01 14:39:57
*/
export const putDevicesDetail = (id, data) => request({
    url: '/api/camera-device-management/api/v1/devices/' + id,
    method: 'PUT',
    data
});
/**
*@Description: 停用设备
*@Date: 2020-09-01 14:39:57
*/
export const offlineDevicesDetail = (id) => request({
    url: '/api/camera-device-management/api/v1/devices/offline/' + id,
    method: 'PUT'
});
/**
*@Description: 删除设备
*@Date: 2020-09-01 14:39:57
*/
export const deleteDevices = (id) => request({
    url: '/api/camera-device-management/api/v1/devices/' + id,
    method: 'DELETE'
});
// export const getDevicesList = (keywords: String, size: number | 10, page: number | 1) =>
//   request({
//     url: '/api/camera-device-management/api/v1/devices/list',
//     method: 'POST',
//     data: { keywords, size, page }
//   })
export const getDevicesList = (data) => request({
    url: '/api/camera-device-management/api/v1/devices/list',
    method: 'POST',
    data
});
/**
*@Description: 查询设备类型
*@Date: 2020-09-01 14:39:57
*/
export const getTypesList = (data) => request({
    url: '/api/camera-device-management/api/v1/devices/types',
    method: 'GET',
    params: {}
});
/**
*@Description: 查询设备类型
*@Date: 2020-09-01 14:39:57
*/
export const activeDevice = (id) => request({
    url: '/api/camera-device-management/api/v1/devices/active/' + id,
    method: 'POST'
});
/**
*@Description:
根据设备ID查询视频预览地址
*@Date: 2020-09-01 14:39:57
*/
export const getRtspPreviewAddress = (deviceId) => request({
    url: '/api/camera-device-management/api/v1/devices/' + deviceId + '/rtsp_preview_address',
    method: 'GET',
    params: {}
});
/** ==============================@Description:设备组 ============================== */
/**
*@Description: 分页查询设备列表
*@Date: 2020-09-01 14:39:57
*/
export const getgroupTree = () => request({
    url: '/api/camera-device-management/api/v1/device-groups/tree',
    method: 'GET',
    params: {}
});
/**
*@Description: 添加设备组
*@Date: 2020-09-01 14:39:57
*/
export const postDevicesGroup = (data) => request({
    url: '/api/camera-device-management/api/v1/device-groups',
    method: 'POST',
    data
});
/**
*@Description: 删除设备组
*@Date: 2020-09-01 14:39:57
*/
export const deleteDevicesGroup = (id) => request({
    url: '/api/camera-device-management/api/v1/device-groups/' + id,
    method: 'DELETE'
});
/**
*@Description: 修改设备组
*@Date: 2020-09-01 14:39:57
*/
export const putDevicesGroup = (id, data) => request({
    url: '/api/camera-device-management/api/v1/device-groups/' + id,
    method: 'PUT',
    data
});
/**
*@Description: 检查设备是否能连通
*@Date: 2020-09-10 18:26:17
*/
export const getcheck = (data) => request({
    url: '/api/camera-device-management/api/v1/devices/check',
    method: 'POST',
    data
});
/**
*@Description: 查询设备组详情
*@Date: 2020-09-01 14:39:57
*/
export const getDevicesGroupDetail = (id) => request({
    url: '/api/camera-device-management/api/v1/device-groups/' + id,
    method: 'GET'
});
/**
*@Description: 查询设备组及其设备
*@Date: 2020-09-01 14:39:57
*/
export const postDevicesGroupTree = () => request({
    url: '/api/camera-device-management/api/v1/device-groups/devices/tree',
    method: 'POST',
    data: { 'groupId': 0 }
});
export const exportDevices = async (param) => {
    const resp = await request({
        url: `/api/camera-device-management/api/v1/device/export`,
        method: 'POST',
        data: { ...param },
    });
    return resp;
};
export const deleteDevicesAll = async (param) => {
    const resp = await request({
        url: `/api/crowd-record-management/api/v1/search/control/records`,
        method: 'DELETE',
        data: { ...param },
    });
    return resp;
};
